export const SUBMISSION_REQUEST_INCLUDES =
  'investment.entity,investment.timePeriod,investment.rootInvestment.entity,' +
  'investment.rootInvestment.organizationAssociations,' +
  'managerOrganization,creator,investment.latestSubmission,investment.entity.strategy,' +
  'investment.entity.productType,' +
  'investment.entity.subStrategy,investment.parent.entity';
